var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"synchronizeTime-wrap"},[_vm._v(" 数据同步时间："+_vm._s(_vm.technician.synchronize_time.replace(/-/g,"."))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }